import { getDefaultStore } from 'jotai';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { AccountResponseT } from '@consumer-frontend/nc-utils';

import {
  accountAtom,
  applyEligibilityAtom,
  doesPasswordExistAtom,
  registrationDataAtom,
} from '../store';

const store = getDefaultStore();

export const REGISTRATION_PAGES_NEEDING_DATA: string[] = [
  uiRoutes.apply.basicInfo,
  uiRoutes.apply.phoneNumber,
  uiRoutes.apply.address,
  uiRoutes.apply.maritalInformation,
];

export const hasIncome = (account: AccountResponseT | undefined): boolean => !!account?.income?.source_of_income;

export const hasRegistrationData = (): boolean => Object.keys(store.get(registrationDataAtom)).length > 0;

export const pageRequiresRegistrationData = (path: string): boolean => REGISTRATION_PAGES_NEEDING_DATA.includes(path);

export const hasPassword = (): boolean => !!store.get(doesPasswordExistAtom);

export const unauthenticatedEntryRoute = (path: string): string | undefined => {
  if (path === uiRoutes.apply.signin) {
    return uiRoutes.legacyAH.signin;
  }

  return !hasRegistrationData() && pageRequiresRegistrationData(path)
    ? uiRoutes.apply.borrowingNeeds
    : undefined;
};

export const authenticatedEntryRoute = (path?: string): string | undefined => {
  if (path === uiRoutes.apply.signin) {
    return uiRoutes.legacyAH.accountSummary;
  }

  if (path === uiRoutes.apply.verifySignin) {
    return undefined;
  }

  return hasPassword() ? uiRoutes.apply.verifyContactInfo : uiRoutes.apply.incomeSource;
};

export const isApplyEligible = (): boolean => {
  const account = store.get(accountAtom);
  const notLockedOut = !(account?.loginLockActive || account?.reapplicationLockActive);

  if (!hasPassword()) { return notLockedOut; }

  return notLockedOut && !!store.get(applyEligibilityAtom)?.eligible;
};
